import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';

Vue.use(ElementUI);
Vue.config.productionTip = false;

// Axios 请求拦截器，自动添加 JWT 到请求头
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwt_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // 将 JWT 添加到请求头中
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Axios 响应拦截器，捕获 401 错误并重定向到登录页面
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // 提示用户登录已失效
      Vue.prototype.$message.error('登录已失效，请重新登录');

      // 清除失效的 token
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('database_name');

      // 重定向到登录页面
      if (router.currentRoute.path !== '/login') {
        router.push('/login');
      }
    }
    return Promise.reject(error);
  }
);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
